import Button from '@zenbusiness/zui/Button';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const IconButtonStyled = styled(Button)(({ theme }) => ({
  padding: 0,
  minWidth: '15px',
  height: '15px',
  [theme.breakpoints.up('md')]: {
    // Override style from zen common style
    height: '15px'
  }
}));

export const CaptionDesc = styled(Text)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    lineHeight: '1.25rem'
  }
}));
